histories-tasks-memo-created
  span.event {this.locale().event}
  span.created
    span.label.label-sm(style="background: {phaseColorCode()}")
      span.day_prefix { this.locale().day_prefix }
      span.day { opts.json.index + 1 }
      span.day_suffix { this.locale().day_suffix }
    span.text { opts.json.text }
    span.num(if="{opts.json.num > 0}")  { opts.json.num }
  script(type="typescript").
    this.mixin('histories.base');
